// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Reset mínimo. Todos los estilos del proyecto se aplican vía
 * styled-components y el componente GlobalStyle (src/styles/GlobalStyle.js).
 * No agregar reglas globales acá — usar GlobalStyle.
 */

html,
body,
#root {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background-color: #000;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;;;EAGE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC","sourcesContent":["/*\n * Reset mínimo. Todos los estilos del proyecto se aplican vía\n * styled-components y el componente GlobalStyle (src/styles/GlobalStyle.js).\n * No agregar reglas globales acá — usar GlobalStyle.\n */\n\nhtml,\nbody,\n#root {\n  margin: 0;\n  padding: 0;\n  min-height: 100vh;\n  background-color: #000;\n}\n\nbody {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
